import React from 'react';
import './Avatar.styles.css';

interface AvatarProps {
  name?: string;
  size?: 'tiny' | 'small' | 'medium' | 'large';
  className?: string;
  style?: React.CSSProperties;
}

export const Avatar: React.FC<AvatarProps> = ({
  name = '',
  size = 'medium',
  className = '',
  style = {}
}) => {
  const getInitials = (fullName: string): string => {
    if (!fullName) return '?';
    const parts = fullName.split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return fullName.substring(0, 2).toUpperCase();
  };

  const getColorFromName = (name: string): string => {
    const colors = [
      '#FF5A5F', // Primary red
      '#4CAF50', // Green
      '#2196F3', // Blue
      '#FFC107', // Yellow
      '#9C27B0', // Purple
      '#FF9800', // Orange
      '#00BCD4', // Cyan
      '#E91E63', // Pink
    ];
    
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  const initials = getInitials(name);
  const backgroundColor = getColorFromName(name);

  return (
    <div
      className={`mes-taches-avatar mes-taches-avatar-${size} ${className}`}
      style={{
        backgroundColor,
        ...style
      }}
      title={name}
    >
      <span className="mes-taches-avatar-initials">{initials}</span>
    </div>
  );
};